"use client";

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Clock } from "lucide-react";

export default function AssetMaintenanceDialog({
  open,
  onOpenChange,
  selectedAsset,
  setSelectedAsset,
  assets,
  newMaintenance,
  setNewMaintenance,
  loading,
  onSubmit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">Add Maintenance Record</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-1 gap-4">
          <div>
            <Label htmlFor="maintenance-asset">Asset</Label>
            <Select
              value={selectedAsset?.asset_id?.toString() || "none"}
              onValueChange={(value) => {
                if (value === "none") {
                  setSelectedAsset(null);
                  return;
                }
                const asset = assets.find((a) => a.asset_id === Number.parseInt(value, 10));
                setSelectedAsset(asset || null);
              }}
            >
              <SelectTrigger id="maintenance-asset">
                <SelectValue placeholder="Select asset" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Select asset</SelectItem>
                {assets.map((asset) => (
                  <SelectItem key={asset.asset_id} value={asset.asset_id.toString()}>{asset.asset_name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label htmlFor="maintenance-date">Date</Label>
            <Input id="maintenance-date" type="date" value={newMaintenance.date} onChange={(e) => setNewMaintenance({ ...newMaintenance, date: e.target.value })} />
          </div>

          <div>
            <Label htmlFor="maintenance-type">Type</Label>
            <Select value={newMaintenance.type} onValueChange={(value) => setNewMaintenance({ ...newMaintenance, type: value })}>
              <SelectTrigger id="maintenance-type"><SelectValue placeholder="Select type" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="Preventive">Preventive</SelectItem>
                <SelectItem value="Corrective">Corrective</SelectItem>
                <SelectItem value="Emergency">Emergency</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label htmlFor="maintenance-description">Description</Label>
            <Textarea id="maintenance-description" rows={3} value={newMaintenance.description} onChange={(e) => setNewMaintenance({ ...newMaintenance, description: e.target.value })} />
          </div>

          <div>
            <Label htmlFor="maintenance-cost">Cost (Rs)</Label>
            <Input id="maintenance-cost" type="number" value={newMaintenance.cost} onChange={(e) => setNewMaintenance({ ...newMaintenance, cost: Number.parseFloat(e.target.value) || 0 })} onFocus={(e) => e.target.select()} />
          </div>

          <div>
            <Label htmlFor="maintenance-technician">Technician</Label>
            <Input id="maintenance-technician" value={newMaintenance.technician} onChange={(e) => setNewMaintenance({ ...newMaintenance, technician: e.target.value })} />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button className="bg-green-600 hover:bg-green-700" onClick={onSubmit} disabled={loading}>
            {loading && <Clock className="mr-2 h-4 w-4 animate-spin" />}
            Add Maintenance Record
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
